import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  setPersistence,
  browserLocalPersistence,
  updateProfile,
  reauthenticateWithCredential,
  EmailAuthProvider,
  deleteUser, // Certifique-se de importar o updateProfile
} from "firebase/auth"; // Agora o User vem de firebase/auth
import { firebaseAuth } from "./Baseconfig";
import { get, getDatabase, ref, remove, set } from "firebase/database";
import { FirebaseError } from "firebase/app";
import { logHistorico } from "../data/userService";

export interface LoginFormValues {
  email: string;
  password: string;
}

export interface UserFormValues {
  email: string;
  password: string;
  displayName: string;
  birthDate: string;
}

// Required if you want to keep logged in after user exits the browser or closes tab
setPersistence(firebaseAuth, browserLocalPersistence);

// Sign in functionality
export const firebaseSignIn = async ({ email, password }: LoginFormValues) => {
  try {
    const result = await signInWithEmailAndPassword(
      firebaseAuth,
      email,
      password
    );
    return result;
  } catch (error) {
    if (error instanceof FirebaseError) {
      throw error;
    } else {
      throw new Error("An unexpected error occurred during sign-in.");
    }
  }
};

// Sign up functionality
export const firebaseSignUp = async ({
  email,
  password,
  displayName,
  birthDate,
}: UserFormValues) => {
  try {
    const result = await createUserWithEmailAndPassword(
      firebaseAuth,
      email,
      password
    );
    const user = result.user;

    // Salvar o nome e aniversário no Realtime Database
    const db = getDatabase();
    await set(ref(db, "users/" + user.uid), {
      displayName: displayName,
      aniversario: birthDate,
    });

    // Atualizar o nome no Auth
    if (user) {
      await updateProfile(user, {
        displayName: displayName,
      });
    }

    return result;
  } catch (error) {
    if (error instanceof FirebaseError) {
      throw error;
    } else {
      throw new Error("An unexpected error occurred during sign-up.");
    }
  }
};

// Sign out functionality
export const firebaseSignOut = async () => {
  try {
    await signOut(firebaseAuth);
  } catch (error) {
    if (error instanceof FirebaseError) {
      throw error;
    } else {
      throw new Error("An unexpected error occurred during sign-out.");
    }
  }
};

// Password reset functionality
export const firebasePasswordReset = async (email: string) => {
  try {
    await sendPasswordResetEmail(firebaseAuth, email);
  } catch (error) {
    if (error instanceof FirebaseError) {
      throw error;
    } else {
      throw new Error("An unexpected error occurred during password reset.");
    }
  }
};

export const deleteAccount = async (password: string) => {
  const user = firebaseAuth.currentUser;

  if (!user || !user.email) {
    throw new Error("Usuário não autenticado.");
  }

  const credential = EmailAuthProvider.credential(user.email, password);
  await reauthenticateWithCredential(user, credential);

  const db = getDatabase();

  // Buscar displayName e totalJogos do banco antes de apagar
  const userSnapshot = await get(ref(db, `users/${user.uid}`));
  const userData = userSnapshot.val();
  const displayName = userData?.displayName || user.displayName || null;
  const totalJogos = userData?.jogosAnual || null;

  // Logar deleção
  await logHistorico("delecao", user.uid, displayName, totalJogos);

  // Remover dados do Realtime Database
  await remove(ref(db, `users/${user.uid}`));

  // Remover conta do Firebase Auth
  await deleteUser(user);
};
